// extracted by mini-css-extract-plugin
module.exports = {"contentGroup":"FeatureItem_contentGroup__cxdAZ","reverse":"FeatureItem_reverse__W0Qr5"};